import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { getAuthentication } from '../../../hooks/useAuthentication';

export default function useMarkStepDone() {
  const navigate = useNavigate();

  const markStepDone = async (stepUrl: string) => {
    const { user } = getAuthentication();
    localStorage.setItem(`current-step-${user?.id}`, stepUrl);
  };

  const onBoardingCompleted = async () => {
    localStorage.removeItem(`current-step-${getAuthentication()?.user?.id}`);
  };

  const checkCurrentStep = useCallback(async () => {
    const authentication = getAuthentication();

    if (authentication?.user?.onboardHomeCompleted || !authentication?.user?.id) {
      return;
    }

    const currentStep = localStorage.getItem(`current-step-${authentication?.user?.id}`);
    const cleanStep = currentStep?.split('?')[0];
    const isValidOnboardingStep = cleanStep && /^\/on-boarding\/step\/\d+$/.test(cleanStep);

    if (isValidOnboardingStep) {
      navigate(cleanStep, { replace: true });
    } else {
      localStorage.removeItem(`current-step-${authentication?.user?.id}`);
      navigate('/on-boarding/step/1', { replace: true });
    }
  }, [navigate]);

  return {
    markStepDone,
    onBoardingCompleted,
    checkCurrentStep,
  };
}
